import { render, staticRenderFns } from "./StructureBlockSubjectNodeView.vue?vue&type=template&id=077a3927"
import script from "./StructureBlockSubjectNodeView.vue?vue&type=script&lang=js"
export * from "./StructureBlockSubjectNodeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports